export default "__VITE_ASSET__Dp_Vj87G__"